import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.scss';
import CustomerListPage from './components/Customer/CustomerListPage';
import NewCustomerPage from './components/Customer/NewCustomer/NewCustomerPage';
import CustomerShowPage from './components/Customer/CustomerShow/CustomerShowPage';
import OrderPage from './components/Order/OrderPage';
import CheckoutPage from './components/Checkout/CheckoutPage';
import Header from './components/Header/Header';
import PaidOrdersPage from './components/Order/Paid/PaidOrdersPage';
import LoginPage from './components/Login/LoginPage';
import InitPage from './components/InitPage';
import AdminOpenOrdersPage from './components/Admin/OpenOrders/AdminOpenOrdersPage';
import DailyTotalsPage from './components/Admin/DailyTotals/DailyTotalsPage';
import NewUserPage from './components/NewUser/NewUserPage';
import TextMessagePage from './components/Admin/TextMessage/TextMessagePage';
import AdminMordyTotalsPage from './components/Admin/MordyTotals/AdminMordyTotalsPage';
import EditCustomerPage from './components/Customer/EditCustomer/EditCustomerPage';
import CreateEsrogsPage from './components/Admin/Esrogs/CreateEsrogsPage';
import CreateAravosPage from './components/Admin/Aravos/CreateAravosPage';
import CreateLulavsPage from './components/Admin/Lulavs/CreateLulavsPage';
import CreateExtrasPage from './components/Admin/Extras/CreateExtrasPage';
import CreateGradesPage from './components/Admin/Grades/CreateGradesPage';
import CreateHadasimPage from './components/Admin/Hadasim/CreateHadasimPage';

const App = () => {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<InitPage />} />
        <Route path="/home" element={<CustomerListPage />} />
        <Route path="/new-customer" element={<NewCustomerPage />} />
        <Route path="/edit-customer" element={<EditCustomerPage />} />
        <Route path="/customer" element={<CustomerShowPage />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/paid-orders" element={<PaidOrdersPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/new-user" element={<NewUserPage />} />
        <Route path="/admin/customer-list" element={<CustomerListPage />} />
        <Route path="/admin/open-orders" element={<AdminOpenOrdersPage />} />
        <Route path="/admin/daily-totals" element={<DailyTotalsPage />} />
        <Route path="/admin/text-message" element={<TextMessagePage />} />
        <Route path="/admin/mordy-totals" element={<AdminMordyTotalsPage />} />
        <Route path="/admin/esrogs" element={<CreateEsrogsPage />} />
        <Route path="/admin/aravos" element={<CreateAravosPage />} />
        <Route path="/admin/lulavs" element={<CreateLulavsPage />} />
        <Route path="/admin/hadasim" element={<CreateHadasimPage />} />
        <Route path="/admin/extras" element={<CreateExtrasPage />} />
        <Route path="/admin/grades" element={<CreateGradesPage />} />
      </Routes>
    </div>
  );
};

export default App;
